<template>
  <el-container class="main">
    <el-aside class="left-aside">
      <AsideNav @open-member="memberPayVisible = true" />
    </el-aside>
    <el-container class="right-main">
      <el-header class="main-top">
        <Header @open-member-history="memberHistoryVisible = true" />
      </el-header>
      <el-main class="main-area">
        <router-view />
      </el-main>
    </el-container>
    <MemberPayDialog
      :visible.sync="memberPayVisible"
      @paid="handleMemberPaid"
      @redeemed="handleMemberRedeemed"
      @open-history="handleOpenMemberHistory"
      @close="handleMemberDialogClose"
    />
    <MemberPurchaseHistoryDialog
      :visible.sync="memberHistoryVisible"
      @contact="memberContactVisible = true"
    />
    <MemberContactDialog
      :visible.sync="memberContactVisible"
      :qr-code="memberContactQrCode"
    />
  </el-container>
</template>

<script>
import Header from "./module/header";
import AsideNav from "./module/nav";
import MemberPayDialog from "@/components/memberPayDialog/MemberRechargeDialog";
import MemberPurchaseHistoryDialog from "@/components/memberPayDialog/components/MemberPurchaseHistoryDialog";
import MemberContactDialog from "@/components/memberPayDialog/components/MemberContactDialog";
import {
  userAcceptRefuse,
  getTaskDetail,
  readUserMessage,
} from "@/services/teamManagement";
import {
  MEMBER_REQUIRED_EVENT,
  resetMemberAccessDialog,
} from "@/services/memberAccess";

// import { createNamespacedHelpers } from "vuex";
// const { mapActions, mapState } = createNamespacedHelpers("ws");

import { mapActions, mapState } from "vuex";

export default {
  name: "LayoutWrap",
  components: {
    Header,
    AsideNav,
    MemberPayDialog,
    MemberPurchaseHistoryDialog,
    MemberContactDialog,
  },
  data() {
    return {
      memberPayVisible: false,
      memberHistoryVisible: false,
      memberContactVisible: false,
      memberContactQrCode: window.MEMBER_SERVICE_QR_CODE || "",
      notifyDialog: null,
      params: {
        page: 1,
        rows: 9,
      },
    };
  },

  computed: {
    ...mapState({
      userInfo: (state) => state.layout.userInfo,
      webSocketMessage: (state) => state.ws.webSocketMessage,
    }),
  },

  async created() {
    // let companyCode = localStorage.getItem("companyCode");
    this.params.page = Number(sessionStorage.getItem("Messagepage")) || 1;

    this.getUserInfo();
    this.getTaskNums();
    window.addEventListener(MEMBER_REQUIRED_EVENT, this.openMemberPayDialog);
  },

  beforeDestroy() {
    window.removeEventListener(MEMBER_REQUIRED_EVENT, this.openMemberPayDialog);
  },

  methods: {
    ...mapActions(["getTaskNums"]),
    openMemberPayDialog() {
      this.memberPayVisible = true;
    },
    handleMemberPaid() {
      resetMemberAccessDialog();
      this.memberPayVisible = false;
    },
    handleMemberRedeemed() {
      resetMemberAccessDialog();
      this.memberPayVisible = false;
    },
    handleOpenMemberHistory() {
      this.memberHistoryVisible = true;
    },
    handleMemberDialogClose() {
      resetMemberAccessDialog();
    },
    //websocket
    // ...mapActions(["UPDATE_LOGIN_INFO"]),
    //获取用户信息
    async getUserInfo() {
      let self = this;
      self.$store.dispatch("layout/userInfo").then((resp) => {
        if (!!resp && resp.status === 200 && resp.success) {
          let result = resp.result;
          let companyCode = result.lastSelectCompany.code;
          localStorage.setItem("myUser", JSON.stringify(result));
          localStorage.setItem("userInfo", JSON.stringify(result));
          localStorage.setItem("sourceAppid", result.sourceAppid);
          localStorage.setItem("companyCode", result.lastSelectCompany.code); // 公司编码
          localStorage.setItem("myCompanyCode", result.lastSelectCompany.code); // 公司编码
          this.$store.dispatch("ws/UPDATE_LOGIN_INFO", result); //保存用户信息
          this.$store.dispatch("layout/checkMembership", result.id);
          self.setNavInfo(companyCode); //获取导航菜单
          // this.$store.dispatch('layout/getRoleResourceInfo', result.id)
        }
      });
    },

    //同意或拒绝邀请
    async accept(msgData, acceptType) {
      let params = {
        id: msgData.id,
        sourceId: msgData.companyCode,
        status: acceptType,
      };
      const res = await userAcceptRefuse(params);
      if (res.success && res.status === 200) {
        this.notifyDialog.close();
        this.$store.dispatch("layout/showhidden");
        if (acceptType === 1 && this.$route.path === "/home/personCenter") {
          // 当弹窗出现在个人中心时，去更新自己加入的团队
          this.bus.$emit("updateMyJoinedTeam");
        }
        if (this.$route.path === "/home/myMessage") {
          this.bus.$emit("updateMessageList");
        }
        if (acceptType === 1) {
          // 更新团队选择下拉框
          this.$store.dispatch("layout/userInfo");
        }
      } else {
        this.$message.closeAll();
        this.$message.error(this.$t("myMessageV2.uninvited"));
      }
      this.notifyDialog.close();
    },

    // 弹窗消息进入编辑器
    async handleEdit(msgData) {
      this.readMessage(msgData.id);
      let { success, result } = await getTaskDetail({
        id: msgData.sourceId,
      });
      this.notifyDialog.close();
      if (success) {
        let path = "/neweditor";
        // let obj = Object();
        // Reflect.set(obj, "fromType", "message");
        // Reflect.set(obj, "taskId", result.id);
        // Reflect.set(obj, "fileId", result.fileId);
        // Reflect.set(obj, "taskType", result.taskType);
        // Reflect.set(obj, "projectId", result.projectId);
        // Reflect.set(obj, "companyCode", result.companyCode);
        // if (parseInt(result.sourceType) === 0) {
        //   Reflect.set(obj, "type", "task");
        // } else if (parseInt(result.sourceType) === 1) {
        //   Reflect.set(obj, "type", "school");
        //   Reflect.set(obj, "type-school", "student-homework");
        // } else if (parseInt(result.sourceType) === 2) {
        //   Reflect.set(obj, "type", "school");
        //   Reflect.set(obj, "type-school", "student-test");
        //   if (result.startTime == null) {
        //     this.$message.closeAll();
        //     this.$message.warning('测试未开始！');
        //     return;
        //   }
        // }
        sessionStorage.setItem("fileName", result.taskName);
        let obj = {
          fromType: "message",
          sourceLang: result.sourceLang,
          targetLang: result.targetLang,
          taskName: result.taskName,
          wordNum: result.sourceWordNum,
          fileSuffix: result.fileUsableSuffix,
          transModel: result.transModel,
          project: 3,
          userId: this.userInfo.id,
          transStatus: 1,
          fileId: result.fileId,
          projectId: result.projectId,
          isSplit: true,
          taskType: result.taskType,
          taskId: result.id,
          companyCode: result.companyCode,
        };
        if (parseInt(result.sourceType) === 0) {
          obj.type = "task";
        } else if (parseInt(result.sourceType) === 1) {
          obj.type = "school";
          obj["type-school"] = "student-homework";
        } else if (parseInt(result.sourceType) === 2) {
          Reflect.set(obj, "type", "school");
          Reflect.set(obj, "type-school", "student-test");
          if (
            result.startTime == null ||
            new Date() < new Date(result.startTime)
          ) {
            this.$message.closeAll();
            this.$message.warning(this.$t("myMessageV2.Testtimenotstarted"));
            return;
          }
        }
        if (msgData.content == "提交了作业，") {
          Reflect.set(obj, "toGrade", 1);
        }
        let routeData = this.$router.resolve({
          path,
          query: {
            key: this.$Base64.encode(JSON.stringify(obj)),
          },
        });
        window.open(routeData.href, "_self");
      }
    },

    async handleCreateToEdit(msgData) {
      this.readMessage(msgData.id);
      let { success, result } = await getTaskDetail({
        id: msgData.sourceId,
      });
      this.notifyDialog.close();
      if (success) {
        let obj = {
          sourceLang: result.sourceLang,
          targetLang: result.targetLang,
          taskName: result.fileName,
          wordNum: result.sourceWordNum,
          userId: this.userInfo.id,
          fileSuffix: result.fileUsableSuffix,
          transModel: result.transModel,
          fileId: result.fileId,
          projectId: result.projectId,
          isSplit: true, // 接口没有，待确定
        };
        sessionStorage.setItem("fileName", result.fileName);
        if (parseInt(result.sourceType) === 0) {
          obj = {
            ...obj,
            project: result.finish,
            transStatus: 2,
            type: "project",
            taskType: 1,
            taskId: null,
            langDesc: result.langDesc,
            progress: result.progress,
            taskCount: result.taskCount,
            finish: result.finish,
          };
        } else if (
          parseInt(result.sourceType) === 1 ||
          parseInt(result.sourceType) === 2
        ) {
          obj.project = 3;
          obj.transStatus = 1;
          obj.type = "school";
          obj.taskType = result.taskType;
          obj.taskId = result.id;
          if (parseInt(result.sourceType) === 1) {
            obj["type-school"] = "teacher-homework";
          } else {
            obj["type-school"] = "teacher-test";
          }
          obj.companyCode = result.companyCode;
        }
        if (msgData.content == "提交了作业，") {
          Reflect.set(obj, "toGrade", 1);
        }
        let routeData = this.$router.resolve({
          path: "/neweditor",
          query: {
            key: this.$Base64.encode(JSON.stringify(obj)),
          },
        });
        window.open(routeData.href, "_self");
      }
    },

    //获取导航信息
    setNavInfo(companyCode) {
      this.$store.dispatch("layout/navInfo", companyCode);
    },

    async readMessage(id) {
      let { success } = await readUserMessage({ id });
      if (!success) {
        return;
      }
      this.$store.dispatch("layout/showhidden");
    },
  },

  watch: {
    memberPayVisible(visible) {
      if (!visible) resetMemberAccessDialog();
    },
    webSocketMessage: {
      handler(msgData) {
        // 小红点
        this.$store.dispatch("layout/showhidden");
        // 编辑器
        this.$store.dispatch("editor/getmyMessage", this.params);
        //任务数量
        this.getTaskNums();

        const h = this.$createElement;

        if (this.notifyDialog) {
          this.notifyDialog.close();
        }

        if (
          ["assignTask", "homeworkTask", "rollBackTask"].includes(msgData.type)
        ) {
          this.notifyDialog = this.$notify({
            message: h("div", { style: { width: "100%", height: "100%" } }, [
              h("div", { style: { color: "#B0B0B0" } }, "刚刚"),
              h("div", { style: { marginTop: "12px", color: "#454545" } }, [
                `${msgData.data.sendName} ${msgData.data.content}`,
                h(
                  "span",
                  {
                    style: { color: "#0078FC", cursor: "pointer" },
                    on: { click: () => this.handleEdit(msgData.data) },
                  },
                  "查看详情"
                ),
              ]),
            ]),
            duration: 10000,
            showClose: false,
            customClass: "notifyDialog",
            offset: 45,
          });
        } else if (msgData.type === "inviteUserSendMessage") {
          this.notifyDialog = this.$notify({
            message: h("div", { style: { width: "100%", height: "100%" } }, [
              h("div", { style: { color: "#B0B0B0" } }, "刚刚"),
              h(
                "div",
                { style: { marginTop: "12px", color: "#454545" } },
                msgData.data.content
              ),
              h(
                "div",
                {
                  class: "btn-group",
                  style: { marginTop: "20px", height: "26px" },
                },
                [
                  h(
                    "el-button",
                    { on: { click: () => this.accept(msgData.data, 2) } },
                    "拒绝"
                  ),
                  h(
                    "el-button",
                    {
                      on: { click: () => this.accept(msgData.data, 1) },
                      attrs: { type: "primary" },
                    },
                    "同意"
                  ),
                ]
              ),
            ]),
            duration: 10000,
            showClose: false,
            customClass: "notifyDialog",
            offset: 45,
          });
        } else if (msgData.type === "cancelClassTask") {
          this.notifyDialog = this.$notify({
            message: h("div", { style: { width: "100%", height: "100%" } }, [
              h("div", { style: { color: "#B0B0B0" } }, "刚刚"),
              h("div", { style: { marginTop: "12px", color: "#454545" } }, [
                `${msgData.data.sendName} ${msgData.data.content}`,
              ]),
            ]),
            duration: 10000,
            showClose: false,
            customClass: "notifyDialog",
            offset: 45,
          });
        } else if (["finishTask"].includes(msgData.type)) {
          // 完成任务项目创建者进编辑器
          this.notifyDialog = this.$notify({
            message: h("div", { style: { width: "100%", height: "100%" } }, [
              h("div", { style: { color: "#B0B0B0" } }, "刚刚"),
              h("div", { style: { marginTop: "12px", color: "#454545" } }, [
                `${msgData.data.sendName} ${msgData.data.content}`,
                h(
                  "span",
                  {
                    style: { color: "#0078FC", cursor: "pointer" },
                    on: { click: () => this.handleCreateToEdit(msgData.data) },
                  },
                  "查看详情"
                ),
              ]),
            ]),
            duration: 10000,
            showClose: false,
            customClass: "notifyDialog",
            offset: 45,
          });
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>

<style lang="less">
.notifyDialog {
  width: 250px;
  height: auto;
  padding: 20px;
  .el-notification__group {
    width: 100%;
    height: 100%;
    margin: 0;
    .el-notification__content {
      margin: 0;
      .btn-group {
        display: flex;
        .el-button {
          width: 54px;
          line-height: 24px;
          padding: 0;
        }
        .el-button + .el-button {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
